import React from 'react';

import classNames from 'classnames';

import { NativeSelectProps } from './NativeSelect.interface';

const getSelectClasses = (className?: string): string =>
  classNames('rds-select', className);

const RdsNativeSelect = React.forwardRef<
  HTMLSelectElement, // The reference type - which element the final ref is attached to.
  NativeSelectProps
>(({ children, className, id, ...others }, forwardedRef) => (
  <select
    className={getSelectClasses(className)}
    id={id}
    ref={forwardedRef}
    {...others}
  >
    {children}
  </select>
));

export default RdsNativeSelect;
